import axios from "axios";
import { BASE_URL, LOGIN_ENDPOINT, VERSION } from "../constants/Constants";

class LoginService{

    login(userEmail, userPassWord){
        sessionStorage.clear();
        return axios.post(BASE_URL+ VERSION + LOGIN_ENDPOINT ,{
            payLoad: {userEmail, userPassWord}
        })
    }

    logout(){
        sessionStorage.clear();
    }
}


export default new LoginService();